import React, { useEffect, useState } from "react";
import { client, urlFor } from "../sanityClient";
import { Link } from "react-router-dom";


const BlogSection = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        client
            .fetch(
                `*[_type == "news"] | order(publishedAt desc) {
                    title,
                    slug,
                    mainImage,
                    excerpt,
                    "category": category->title,
                    publishedAt
                }`
            )
            .then((data) => setPosts(data))
            .catch(console.error);
    }, []);

    return (
        <section className="container bg-[#33367b] mx-auto py-4 sm:py-16 px-4 ">
            <div className="container mx-auto flex flex-col items-center pb-6 mb-4 md:p-10 md:px-12">
                <h2 className=" mx-2 text-white text-3xl sm:text-4xl font-semibold leading-normal text-center">Xu hướng và tin tức</h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mx-4">
                {/* Lấy tối đa 3 bài viết */}
                {posts.slice(0, 3).map((post, index) => (
                    <Link
                        to={`/news/${post.slug.current}`}
                        key={post.slug.current}
                        className="w-full mx-auto max-w-[500px] p-4 transition-all duration-300  "
                    >
                        {/* Hình ảnh bài viết */}
                        <img
                            src={urlFor(post.mainImage).url()}
                            alt={post.title}
                            className="w-full h-[260px] sm:h-[310px] lg:h-[365px] border-2 object-cover transition-transform duration-300 hover:scale-105"
                        />
                        {/* Tiêu đề */}
                        <h3 className="text-xl font-medium text-white mt-4">
                            {post.title}
                        </h3>
                        {/* Thể loại */}
                        <p className="text-base text-[#BEAB81] ">
                            {post.category}
                        </p>
                        {/* Mô tả ngắn */}
                        <p className="text-base text-gray-300 mt-2">
                            {post.excerpt}
                        </p>
                        {/* Ngày đăng */}
                        <p className="text-sm text-gray-400 mt-2">
                            {new Date(post.publishedAt).toLocaleDateString("vi-VN")}
                        </p>
                    </Link>
                ))}
            </div>
        </section>

)
    ;
};

export default BlogSection;
